import styled from 'styled-components';

export const ListContainer = styled.div`
  max-height: 350px;
  overflow: auto;
`;
